import { createSlice } from '@reduxjs/toolkit';

import { TollState } from '../../types';
import { TOLL_STATE } from '../..//constants';
import { setActiveTollSection } from './setActiveTollSection';

const initialState: TollState = {
  activeTollSection: null,
};

export const tollSlice = createSlice({
  name: TOLL_STATE,
  initialState,
  reducers: {
    setActiveTollSection,
  },
  extraReducers: (builder) => {},
});

export const tollActions = tollSlice.actions;
export const tollReducer = tollSlice.reducer;
